import { FC, useCallback } from 'react';
import commonModalClass from '../../assets/scss/CommonModal.module.scss';
import { postMessageGtag } from '../../utils/trackClick';
import { Prevention } from '../../api/graphql/prevention/types';

export const PreventionImages: FC<{
  preventionList: Prevention[];
  route: string;
}> = ({ preventionList, route }) => {
  const onClickBanner = useCallback(
    (index: number) => {
      if (route === 'skip') {
        postMessageGtag('click_banner' + index + '_skip', 'detailCalender');
      }
    },
    [route]
  );

  if (preventionList.length === 0) return null;

  return (
    <div className={commonModalClass.preventionContainer}>
      {preventionList.map((data, index) => (
        <div className={commonModalClass.preventionImageBox}>
          {data.url ? (
            <a
              href={data.url}
              target="_top"
              onClick={() => onClickBanner(index)}
            >
              <img
                src={data.image}
                alt=""
              />
            </a>
          ) : (
            <img
              src={data.image}
              alt=""
            />
          )}
        </div>
      ))}
    </div>
  );
};
